function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m456.835938 0h-401.667969c-30.421875 0-55.167969 24.746094-55.167969 55.167969v401.667969c0 30.417968 24.746094 55.164062 55.167969 55.164062h401.667969c30.417968 0 55.164062-24.746094 55.164062-55.164062v-401.667969c0-30.421875-24.746094-55.167969-55.164062-55.167969zm-401.667969 30h401.667969c13.875 0 25.164062 11.289062 25.164062 25.167969v105.5h-452v-105.5c0-13.878907 11.289062-25.167969 25.167969-25.167969zm401.667969 452h-401.667969c-13.878907 0-25.167969-11.289062-25.167969-25.164062v-266.167969h452v266.167969c0 13.875-11.289062 25.164062-25.164062 25.164062zm0 0",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m416.667969 401.667969h-321.332031c-8.285157 0-15 6.714843-15 15 0 8.28125 6.714843 15 15 15h321.332031c8.28125 0 15-6.71875 15-15 0-8.285157-6.71875-15-15-15zm0 0",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m416.671875 110.328125c3.949219 0 7.808594-1.597656 10.597656-4.386719 2.800781-2.792968 4.402344-6.660156 4.402344-10.613281 0-3.949219-1.601563-7.808594-4.402344-10.597656-2.789062-2.800781-6.648437-4.402344-10.597656-4.402344-3.953125 0-7.820313 1.601563-10.613281 4.402344-2.789063 2.789062-4.386719 6.648437-4.386719 10.597656 0 3.953125 1.597656 7.820313 4.386719 10.613281 2.792968 2.789063 6.660156 4.386719 10.613281 4.386719zm0 0",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m336.328125 110.328125c3.953125 0 7.820313-1.597656 10.613281-4.386719 2.789063-2.792968 4.386719-6.660156 4.386719-10.613281 0-3.949219-1.597656-7.808594-4.386719-10.597656-2.792968-2.800781-6.660156-4.402344-10.613281-4.402344-3.9375 0-7.808594 1.601563-10.597656 4.402344-2.789063 2.789062-4.402344 6.648437-4.402344 10.597656 0 3.953125 1.613281 7.820313 4.402344 10.613281 2.789062 2.789063 6.648437 4.386719 10.597656 4.386719zm0 0",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m256 110.328125c3.949219 0 7.808594-1.597656 10.609375-4.386719 2.789063-2.792968 4.390625-6.660156 4.390625-10.613281 0-3.949219-1.601562-7.808594-4.390625-10.597656-2.800781-2.800781-6.660156-4.402344-10.609375-4.402344s-7.808594 1.601563-10.609375 4.402344c-2.789063 2.789062-4.390625 6.648437-4.390625 10.597656 0 3.953125 1.601562 7.820313 4.390625 10.613281 2.789063 2.789063 6.660156 4.386719 10.609375 4.386719zm0 0",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m95.335938 110.332031h80.332031c8.28125 0 15-6.714843 15-15 0-8.28125-6.71875-15-15-15h-80.332031c-8.285157 0-15 6.71875-15 15 0 8.285157 6.714843 15 15 15zm0 0",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m135.5 351.335938c30.417969 0 55.167969-24.75 55.167969-55.167969 0-30.421875-24.75-55.167969-55.167969-55.167969s-55.164062 24.746094-55.164062 55.167969c0 30.417969 24.746093 55.167969 55.164062 55.167969zm0-80.335938c13.878906 0 25.167969 11.289062 25.167969 25.167969 0 13.875-11.289063 25.167969-25.167969 25.167969s-25.164062-11.292969-25.164062-25.167969c0-13.878907 11.285156-25.167969 25.164062-25.167969zm0 0",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m416.667969 241h-160.667969c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h160.667969c8.28125 0 15-6.714844 15-15s-6.71875-15-15-15zm0 0",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m416.667969 321.335938h-160.667969c-8.285156 0-15 6.714843-15 15 0 8.28125 6.714844 15 15 15h160.667969c8.28125 0 15-6.71875 15-15 0-8.285157-6.71875-15-15-15zm0 0",
    "data-original": "#000000",
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.1d0d4f68ee0373564a7e38eefdd016e2.svg";
export { ForwardRef as ReactComponent };